<template>
    <el-dialog class="dialog" :visible="dialogs.workFunctionsItemRename" customClass="dialog_main" :append-to-body="true" :close-on-click-modal="false" @close="closeDialog()" @open="handleOpen">
        <div slot="title" class="dialog__head dialog__head_second">
            <div class="dialog__head-inner">
                <h3 class="dialog__title">{{ title }}</h3>
            </div>
        </div>

        <div slot="default" class="dialog__inner">
            <form
                action="#"
                class="dialog__form"
                @submit.prevent="renameWorkFunctionItem($event)"
                autocomplete="off"
            >
                <input type="text" name="name" class="input" placeholder="Название" v-model="name">

                <footer slot="footer" class="dialog__footer mt-24">
                    <div class="dialog__footer-inner">
                        <div class="dialog__footer-item"></div>
                        
                        <div class="dialog__footer-item">
                            <button type="submit" class="btn btn_action">
                                Применить
                            </button>
                        </div>
                    </div>
                </footer>
            </form>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import constants from '@/constants.js';
import dialog from '@/mixins/dialog';

export default {
    mixins: [ dialog ],
    props: {
        activeWorkFunctionItem: {
            required: true,
            type: Object,
            default: function() {
                return {}
            }
        }
    },
    data() {
        return {
            name: ''
        }
    },
    methods: {
        ...mapActions('editor', ['UPDATE_WORK_ACTION', 'UPDATE_WORK_KNOWLEDGE', 'UPDATE_WORK_SKILL']),

        closeDialog() {
            this.elDialogs.workFunctionsItemRename = false;
        },
        renameWorkFunctionItem(e) {
            switch (this.activeWorkFunctionItem.type) {
                case 'action':
                    this.renameWorkAction(e)
                    break
            
                case 'knowledge':
                    this.renameWorkKnowledge(e)
                    break
            
                case 'skill':
                    this.renameWorkSkill(e)
                    break
            
                default:
                    return
            }
        },
        async renameWorkAction(e) {
            const formData = new FormData(e.target);

            const params = this.activeWorkFunctionItem
            params.workActionId = this.activeWorkFunctionItem.id

            for (const pair of formData.entries()) {
                params[pair[0]] = pair[1];
            }

            await this.UPDATE_WORK_ACTION(params)
            this.$emit('updateItems')

            this.closeDialog()
        },
        async renameWorkKnowledge(e) {
            const formData = new FormData(e.target);

            const params = this.activeWorkFunctionItem
            params.workKnowledgeId = this.activeWorkFunctionItem.id

            for (const pair of formData.entries()) {
                params[pair[0]] = pair[1];
            }

            await this.UPDATE_WORK_KNOWLEDGE(params)
            this.$emit('updateItems')

            this.closeDialog()
        },
        async renameWorkSkill(e) {
            const formData = new FormData(e.target);

            const params = this.activeWorkFunctionItem
            params.workSkillId = this.activeWorkFunctionItem.id

            for (const pair of formData.entries()) {
                params[pair[0]] = pair[1];
            }

            await this.UPDATE_WORK_SKILL(params)
            this.$emit('updateItems')

            this.closeDialog()
        },
        handleOpen() {
            this.$nextTick(() => {
                this.name = this.activeWorkFunctionItem.name;
            });
        }
    },
    computed: {
        title() {
            switch (this.activeWorkFunctionItem.type) {
                case 'action':
                    return 'Редактировать трудовое действие'
            
                case 'knowledge':
                    return 'Редактировать знание'
            
                case 'skill':
                    return 'Редактировать умение'
            
                default:
                    return ''
            }
        }
    },
    mounted() {
        this.name = this.activeWorkFunctionItem.name;
    }
}
</script>
